var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBnbLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    id: "bnb",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.75 80.02V67.53l-10.16 5.86v12.5l10.16-5.87z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m91.75 47.98-10.54-6.09L64 51.83l-17.21-9.94-10.54 6.09v11.07l17.5 10.11v20.97L64 96.05l10.25-5.92V69.16l17.5-10.11V47.98zM109.35 48.89V37.82l-10.54-6.09-10.26 5.92 10.54 6.09v11.07l10.26-5.92zM28.91 54.81V43.74l10.54-6.09-10.26-5.92-10.54 6.09v11.07l10.26 5.92z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m36.25 80.02 10.16 5.87v-12.5l-10.16-5.86v12.49zM74.25 98.61 64 104.53l-10.25-5.92v11.84L64 116.37l10.25-5.92V98.61zM73.87 37.65 64 31.95l-9.87 5.7 9.87 5.7 9.87-5.7zM99.09 63.29v20.97l-17.5 10.11v11.84l27.76-16.03V57.37l-10.26 5.92z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m46.41 94.37-17.5-10.11V63.29l-10.26-5.92v32.81l27.76 16.03V94.37zM46.79 33.41 64 23.48l17.21 9.93 10.26-5.92L64 11.63 36.53 27.49l10.26 5.92z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnbLogo);
export default __webpack_public_path__ + "static/media/bnb-logo.0d98dc35a42304de2f522fd6ae60c382.svg";
export { ForwardRef as ReactComponent };